import { Tab, TabGroup, TabList, TabPanels, TabPanel } from "@headlessui/react";
import { useState } from "react";
import PvSmallMultipleLocation from "./PvSmallMultipleLocation";
import PvSmallMultipleSize from "./PvSmallMultipleSize";
import WindSmallMultipleSize from "./WindSmallMultipleSize";
import BiomasseSmallMultipleSize from "./BMSmallMultipleSize";
import WasserkrafteSmallMultipleSize from "./HPSmallMultipleSize";
import EmblaCarousel from "./CarouselComponent";
import EnergyAdditionTemplate from "./annual-addition-section/EnergyAdditionTemplate";

const tabData = [
  { name: "Photovoltaik", color: "#ffcd00", disabled: false },
  { name: "Windkraft", color: "#1e90ff", disabled: false },
  { name: "Biomasse", color: "#8B4513", disabled: false },
  { name: "Wasserkraft", color: "#40E0D0", disabled: false },
];

export default function TabsComponent({ location_key }) {
  const [selectedIndex, setSelectedIndex] = useState(0);

  return (
    <div className="m-5">
      <TabGroup selectedIndex={selectedIndex} onChange={setSelectedIndex}>
        {/* Tab Buttons */}
        <TabList className="flex w-full shadow-lg">
          {tabData.map((tab) => (
            <Tab
              key={tab.name}
              disabled={tab.disabled}
              className={`w-full py-2 px-4 text-center border rounded-t-lg bg-white data-[hover]:bg-gray-200 data-[selected]:bg-black data-[selected]:text-white
                ${tab.disabled ? "opacity-50 cursor-not-allowed" : ""}`}
            >
              {tab.name}
            </Tab>
          ))}
        </TabList>

        {/* Tab Content Panels */}
        <TabPanels className="py-4 border bg-white shadow-lg rounded-b-lg">
          {tabData.map(
            (tab) =>
              !tab.disabled && (
                <TabPanel key={tab.name}>
                  {tab.name === "Photovoltaik" ? (
                    <>
                      <EmblaCarousel>
                        <div className="min-w-full px-4">
                          <PvSmallMultipleLocation
                            title="Photovoltaikanlagen nach Typ"
                            location_key={location_key}
                            colors={["#E0E0E0", tab.color]}
                          />
                        </div>
                        <div className="min-w-full px-4">
                          <PvSmallMultipleSize
                            title="Photovoltaikanlagen nach Größenklassen"
                            location_key={location_key}
                            colors={["#E0E0E0", tab.color]}
                          />
                        </div>
                      </EmblaCarousel>
                      <EnergyAdditionTemplate
                        source="PV"
                        title="Historischer Zubau an Photovoltaikanlagen"
                        yAxisLabel="Netto Zubau (MWp)"
                        location_key={location_key}
                        barColor={tab.color}
                        unit='MWp'
                      />
                    </>
                  ) : tab.name === "Windkraft" ? (
                    <>
                      <div className="min-w-full px-4">
                        <WindSmallMultipleSize
                          title="Windkraftanlagen nach Leistungsklassen"
                          location_key={location_key}
                          colors={["#E0E0E0", tab.color]}
                        />
                      </div>
                      <EnergyAdditionTemplate
                        source="WP"
                        title="Historischer Zubau an Windkraftanlagen"
                        location_key={location_key}
                        barColor={tab.color}
                        unit='MW'
                      />
                    </>
                  ) : tab.name === "Biomasse" ? (
                    <>
                      <div className="min-w-full px-4">
                        <BiomasseSmallMultipleSize
                          title="Biomasseanlagen nach Leistungsklassen"
                          location_key={location_key}
                          colors={["#E0E0E0", tab.color]}
                        />
                      </div>
                      <EnergyAdditionTemplate
                        source="BM"
                        title="Historischer Zubau an Biomasseanlagen"
                        location_key={location_key}
                        barColor={tab.color}
                        unit='MW'
                      />
                    </>
                  ) : tab.name === "Wasserkraft" ? (
                    <>
                      <div className="min-w-full px-4">
                        <WasserkrafteSmallMultipleSize
                          title="Wasserkraftanlagen nach Leistungsklassen"
                          location_key={location_key}
                          colors={["#E0E0E0", tab.color]}
                        />
                      </div>
                      <EnergyAdditionTemplate
                        source="HP"
                        title="Historischer Zubau an Wasserkraftanlagen"
                        location_key={location_key}
                        barColor={tab.color}
                        unit='MW'
                      />
                    </>
                  ): null}
                </TabPanel>
              )
          )}
        </TabPanels>
      </TabGroup>
    </div>
  );
}
